import { useMutation } from 'react-query';

import { createTeamUser, userCreateParams } from '@utils/backend-api/users';

export default function useCreateTeamUser() {
  const { mutateAsync, data, isLoading, isError } = useMutation((params: userCreateParams) =>
    createTeamUser(params)
  );
  return { mutateAsync, data, isLoading, isError };
}
